<template>
<div>

<!-- Photo & link to my CV -->
    <section class="aboutMe">
        <div id="quiSuisJe">
            <div class="maPhoto"></div>
        </div>
    </section>
        <div class="boutonCv">
            <a href="CV-Emmanuel-Trepant.pdf" target="_self">
                <div id="conteneur_monAnimation">Lire mon CV (PDF)</div>
            </a>
        </div>
        <div class="content">
            <!-- About Me & links -->          
            <section class="introduction">
                    <div>{{introTexte}}</div>
                    <p><b>Mes différents services (sites) et portfolio photographique<br /></b>
                        <a href="http://www.goslide.be" target="_self">Go Slide</a> |
                        <a href="https://www.flickr.com/photos/manu_trepant/" target="_self">FlickR</a> |
                        <a href="http://www.hamsterquiz.com" target="_self">Hamster Quiz</a> |
                        <a href="http://www.rhinopixel.com" target="_self">Rhinopixel</a>
                    </p>
            </section>
        </div>
</div>
</template>

<script>
    export default {
    name: 'IntroV',
        data() {    
        return    {
                    monCv : 'CV-Emmanuel-Trepant.pdf',
                    introTexte :"Merci de votre visite sur mon portfolio, CV, je m'appelle Emmanuel Trépant, licencié en publicité et graphisme. Actif depuis 1998 dans le domaine du graphisme, les présentations Powerpoint, la création de médias pour les médias sociaux et le web design. FrontEnd Développeur depuis mars 2020",  
                    }
                }
    };

    //   Animation 'Lire mon CV' OK

        function BoutonAnimation() {
            document.getElementById('conteneur_monAnimation').classList.add('monAnimation');
        }

        // Check si l'element passé en param est affiché sur l'écran
        function checkVisible(elm) {
            let rect = elm.getBoundingClientRect();
            let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
        }

        //Regarde si la div est affichée toutes les 250ms puis désactive l'interval
        let interval = setInterval(function () {
            if (checkVisible(document.getElementById('conteneur_monAnimation'))) {
                BoutonAnimation();
                clearInterval(interval); // Désactive le SetInterval
            }
        }, 250);
</script>

<style scoped>

        .introduction {
        background-color: rgb(241, 238, 238);
        text-align: center;
        padding: 40px;
        }

        .introduction p b {
        font-weight:900;
        font-size: 17px;
        }

        .aboutMe {
        background-color: #428bca;
        display: flex;
        justify-content: center;
        text-align: center;
        }

        .maPhoto {
        border-radius: 50%;
        background-image: url("../assets/images/emmanuel-trepant.jpg");
        background-repeat: no-repeat;
        width: 140px;
        height: 140px;
        margin: auto;
        }

        .boutonCv,
        .boutonCv a {
        width: 100%;
        height: 70px;
        background-color: #428bca;
        color: white;
        }

        .aboutMeLink:hover,
        .monAnimation:hover,
        .monCv:hover {
        background-color: white;
        color: #428bca;
        -webkit-box-shadow: 6px 10px 12px -4px rgba(0, 0, 0, 0.4);
        -moz-box-shadow: 6px 10px 12px -4px rgba(0, 0, 0, 0.4);
        box-shadow: 6px 10px 12px -4px rgba(0, 0, 0, 0.4);
        opacity: 1;
        transition: 1s;
        }

        .monAnimation {
        display: inline-block;
        border: 1px solid white;
        font-size: 14px;
        font-weight: bolder;
        padding: 16px 60px;
        border-radius: 3px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        position: relative;
        animation-name: DeplacementDuDiv;
        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-timing-function: ease;
        }

        @keyframes DeplacementDuDiv {
        from {
            left: 0;
        }

        to {
            left: calc(50% - 118px);
        }
        }

/* Fin Animation bouton */
</style>